module.exports = __webpack_public_path__ + "static/media/SixthContainerImage.c6a709fe.webp";